import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { AranToolkitModule } from '@aran-client/aran-web-ui-toolkit';
import { AreaTypePipe } from './pipes/area-type/area-type.pipe';
import { FilterByTextPipe } from './pipes/filter-by-text/filter-by-text.pipe';
import { InputPswCriteriaComponent } from './components/input-psw-criteria/input-psw-criteria.component';
import { FilterBySubTopicStatusPipe } from './pipes/filter-by-sub-topic-status/filter-by-sub-topic-status.pipe';

@NgModule({
  declarations: [
    AreaTypePipe,
    FilterByTextPipe,
    InputPswCriteriaComponent,
    FilterBySubTopicStatusPipe,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AranToolkitModule,
  ],
  exports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    AranToolkitModule,
    AreaTypePipe,
    FilterByTextPipe,
    InputPswCriteriaComponent,
    FilterBySubTopicStatusPipe,
  ],
  providers: [DatePipe],
})
export class SharedModule {}
